import { jsx as _jsx } from "react/jsx-runtime";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { categoriesStore } from "../../../../stores/useCategoriesStore";
import { textFieldStyle } from "../../../../assets/styles/styles";
export const CategoryFilterComboBox = ({ sx = {} }) => {
    const options = categoriesStore.useCategories();
    const categories = categoriesStore.useCategoryFilters();
    return (_jsx(Autocomplete, { multiple: true, id: "category-filter-tags", options: options, getOptionLabel: (option) => `${option.name} (${option.shortName})`, onChange: (_event, newValue) => {
            categoriesStore.setCategoryFilters(newValue);
        }, value: categories, filterSelectedOptions: true, limitTags: 3, sx: { width: 300, ...textFieldStyle, ...sx }, renderInput: (params) => (_jsx(TextField, { ...params, variant: 'outlined', label: "filter by category", placeholder: "select a category" }, void 0)) }, void 0));
};
//# sourceMappingURL=CategoryFilterComboBox.js.map